module.exports = __webpack_public_path__ + "static/desktop/img/hero-en1.7e86beb9.webp";